<template>
    <v-container grid-list-md fluid>
        <v-tabs v-model="activeTab" style="border-radius: 16px; overflow: hidden">
            <v-tab value="CompanyScopes" href="#CompanyScopes">Perimètres</v-tab>
            <v-tab value="DuplicatesAndOrphans" href="#DuplicatesAndOrphans"
                >Doublons & Orphelins</v-tab
            >
        </v-tabs>
        <v-tabs-window v-model="activeTab">
            <v-window-item value="CompanyScopes">
                <v-row no-gutters class="d-flex justify-center">
                    <v-col cols="12">
                        <v-row no-gutters cols="12" class="my-3 justify-center">
                            <v-col cols="2">
                                <v-btn-primary
                                    block
                                    height="40px"
                                    elevation="0"
                                    class="rounded-lg gradient"
                                    @click="routeEdition()"
                                    data-cy="WordingAnalysisTable-add"
                                >
                                    Ajouter
                                </v-btn-primary>
                            </v-col>
                            <v-col cols="10" class="pl-2">
                                <v-text-field
                                    v-model="search"
                                    label="Recherche"
                                    clearable
                                    @click:clear="search = ''"
                                    hide-details
                                    density="compact"
                                >
                                    <template #append-inner>
                                        <v-menu
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            offset-y
                                            left
                                            bottom
                                            elevation="1"
                                        >
                                            <template v-slot:activator="{ props }">
                                                <v-btn-icon
                                                    elevation="0"
                                                    icon="$tune"
                                                    size="small"
                                                    style="margin-top: -2px"
                                                    v-bind="props"
                                                    data-cy="ossFilterBar-dialog"
                                                />
                                            </template>

                                            <v-card
                                                :class="{
                                                    'pa-3 pb-0': true,
                                                    'mt-3': $vuetify.display.mobile,
                                                }"
                                                elevation="1"
                                                :style="{
                                                    width: !$vuetify.display.mobile
                                                        ? '700px'
                                                        : undefined,
                                                }"
                                            >
                                                <v-row no-gutters>
                                                    <v-col cols="12">
                                                        <h3>Filtres</h3>
                                                    </v-col>
                                                </v-row>
                                                <v-row no-gutters class="py-2">
                                                    <v-col
                                                        :cols="$vuetify.display.mobile ? '12' : '4'"
                                                        :class="
                                                            $vuetify.display.mobile
                                                                ? 'pa-1'
                                                                : 'px-1'
                                                        "
                                                        data-cy="scopeFilterBar-client"
                                                    >
                                                        <v-text-field-filled
                                                            v-model="clientSearch"
                                                            label="Filtrer par client"
                                                            :hide-details="true"
                                                        />
                                                    </v-col>
                                                    <v-col
                                                        :cols="$vuetify.display.mobile ? '12' : '4'"
                                                        :class="
                                                            $vuetify.display.mobile
                                                                ? 'pa-1'
                                                                : 'px-1'
                                                        "
                                                        data-cy="scopeFilterBar-activity"
                                                    >
                                                        <v-text-field-filled
                                                            v-model="activitySearch"
                                                            label="Filtrer par activité"
                                                            :hide-details="true"
                                                        />
                                                    </v-col>
                                                    <v-col
                                                        :cols="$vuetify.display.mobile ? '12' : '4'"
                                                        :class="
                                                            $vuetify.display.mobile
                                                                ? 'pa-1'
                                                                : 'px-1'
                                                        "
                                                        data-cy="scopeFilterBar-taxSystem"
                                                    >
                                                        <!-- <v-combobox-filled
                                                            v-model="taxSystemSearch"
                                                            label="Filtrer par régime"
                                                            :items="taxSystemList"
                                                            :hide-details="true"
                                                            :return-object="false"
                                                            multiple
                                                        /> -->
                                                        <v-select-filled
                                                            v-model="taxSystemSearch"
                                                            label="Filtrer par régime"
                                                            :items="taxSystemList"
                                                            :hide-details="true"
                                                        />
                                                    </v-col>
                                                </v-row>
                                                <v-divider />
                                                <v-card-actions
                                                    class="d-flex justify-space-between"
                                                >
                                                    <v-btn-reset
                                                        @click.stop="clearAllFilters()"
                                                        data-cy="scopeFilterBar-resetFilter"
                                                        size="small"
                                                    >
                                                    </v-btn-reset>
                                                    <v-btn
                                                        @click="menu = false"
                                                        data-cy="scopeFilterBar-validate"
                                                        size="small"
                                                        variant="tonal"
                                                    >
                                                        Valider
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-menu>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <RuleTable
                        :rule="'companyScope'"
                        :items="formattedScopes"
                        :allTargets="true"
                        :hideDeletion="true"
                        :hideDuplication="true"
                        :accountingCompanyId="accountingCompanyId"
                        :patternCount="patternCount"
                        :firstRequestDone="firstRequestDone"
                        :pagination="pagination"
                        @to-route="routeEdition($event.id)"
                        :maxHeight="maxHeightRT"
                    ></RuleTable>
                </v-row>
            </v-window-item>
            <v-window-item value="DuplicatesAndOrphans">
                <v-row no-gutters cols="12" class="pt-1 justify-center">
                    <v-radio-group
                        v-model="orphans"
                        inline
                        class="d-flex justify-center"
                        color="primary"
                    >
                        <v-radio label="Doublons" :value="false" class="d-flex align-center" />
                        <v-radio label="Orphelins" :value="true" class="d-flex align-center" />
                    </v-radio-group>
                </v-row>
                <v-row no-gutters v-if="loadingDuplicate" class="d-flex justify-center">
                    <v-col cols="8">
                        <v-card class="default_card" elevation="0" pa-0 style="margin: 5px">
                            <v-row class="d-flex align-center">
                                <v-col cols="2">
                                    <v-skeleton-loader type="avatar" />
                                </v-col>
                                <v-col cols="9">
                                    <v-skeleton-loader type="heading" class="my-3" />
                                    <v-skeleton-loader type="text" class="my-auto" />
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <RuleTable
                    ref="ruleComponent"
                    :rule="'companyScope'"
                    :getTitle="getTitle"
                    :items="filteredScopeList"
                    :allTargets="true"
                    :hideStatus="true"
                    :hideTargets="orphans"
                    :hideEdition="true"
                    :hideDeletion="true"
                    :hideDuplication="true"
                    :hideIntersection="true"
                    @to-route="selectDuplicates($event)"
                ></RuleTable>
            </v-window-item>
        </v-tabs-window>
        <oss-dialog
            v-model="childrenDialog"
            title="Doublons"
            :valid-title="orphans ? 'Supprimer' : 'Fusionner'"
            :error="true"
            :validDisabled="disableChildrenValid"
            @close="true"
            @valid="scopesMerge()"
            :validLoading="childrenValidLoading"
            width="800px"
        >
            <v-row no-gutters>
                <v-col cols="12">
                    <template
                        v-for="(value, key) in getTargets(selectedChildrenList[0])"
                        :key="value + key"
                    >
                        <div
                            v-if="value"
                            class="d-flex py-2 align-center justify-center text-subtitle-1"
                        >
                            <v-icon
                                size="x-small"
                                class="mr-2"
                                :icon="iconMapping[key]"
                                color="secondary"
                            />
                            {{ value }}
                        </div>
                    </template>
                </v-col>
                <v-divider />
            </v-row>
            <v-row no-gutters>
                <oss-data-table
                    :headers="childrenHeaders"
                    :items="selectedChildrenList"
                    :fixed-header="true"
                    :table-hover="true"
                    :striped="true"
                    :dense="true"
                    :virtual-scroll="true"
                    :displayRowNumber="true"
                    :showSelect="true"
                    :checkboxDisplayCondition="isCheckable"
                    v-model="toMergeOrDeleteScopes"
                    checkbox-color="primary"
                    class="table elevation-0"
                    height="60vh"
                >
                    <template v-slot:item.checkbox="{ isSelected, onSelect }">
                        <v-checkbox
                            class="pa-0 my-0 ml-3"
                            :ripple="false"
                            color="primary"
                            :model-value="isSelected"
                            @click.stop="onSelect"
                            density="compact"
                            hide-details
                        ></v-checkbox>
                    </template>
                    <template v-slot:item.view="{ item }">
                        <v-menu
                            location="end"
                            :open-on-hover="true"
                            :open-on-click="false"
                            :key="'menu' + item.key"
                            v-if="item._count > 0"
                        >
                            <template v-slot:activator="{ props }">
                                <v-btn-icon icon="$oss-eye" v-bind="props" />
                            </template>
                            <v-list :items="getItems(item)" />
                        </v-menu>
                    </template>
                </oss-data-table>
            </v-row>
        </oss-dialog>
    </v-container>
</template>
<script lang="ts">
import { User } from "../../store/store";
import { Apollo } from "@/decorators";
import { Component, Vue, toNative, Ref } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

import SCOPES_MERGE from "../../graphql/CompanyScopesMerge.gql";
import DELETE_SCOPES from "../../graphql/CompanyScopesDeleteMany.gql";
import COMPANY_SCOPES from "../../graphql/CompanyScopes.gql";
import COMPANY_SCOPES_LIST from "../../graphql/CompanyScopesList.gql";
import OssDataTable from "../ossComponents/ossDataTable2.vue";
import RuleTable from "./RuleTable.vue";

@Component({
    components: {
        OssDataTable,
        RuleTable,
    },
})
export class CompanyScopeTable extends Vue {
    @Ref() readonly ruleComponent: any;
    activeTab = "CompanyScopes";

    orphans = false;
    menu = false;

    headers: Array<any> = [
        { text: "Nom", value: "name", sortable: false, align: "center" },
        { text: "Description", value: "description", sortable: false, align: "left" },
        { text: "Type", value: "type", sortable: false, align: "left" },
    ];

    childrenHeaders: Array<any> = [
        { text: "Nom", value: "name", sortable: false, align: "left", width: "70%" },
        { text: "Utilisations", value: "_count", sortable: false, align: "center", width: "15%" },
        { text: "Règles", value: "view", sortable: false, align: "center", width: "5%" },
    ];

    selected: any = {
        index: 0,
        id: "",
    };

    loading: boolean = true;
    loadingDuplicate: boolean = true;
    firstRequestDone = false;
    loadingStateNext = true;
    patternCount: number = 0;

    pagination: any = {
        page: 1,
        rowsPerPage: 20,
        sortBy: "name",
    };

    search = "";
    clientSearch = "";
    activitySearch = "";
    taxSystemSearch = "";

    get taxSystemList() {
        return [
            { value: "", title: "Indifférent" },
            { value: "RS_IS", title: "BIC régime simplifié à l'Impôt sur les Sociétés" },
            { value: "RS_IR", title: "BIC régime simplifié à l'Impôt sur le Revenu" },
            { value: "RN_IS", title: "BIC régime normal à l'Impôt sur les Sociétés" },
            { value: "RN_IR", title: "BIC régime normal à l'Impôt sur le Revenu" },
            { value: "BIC", title: "BIC" },
            { value: "BNC", title: "BNC" },
            { value: "RF", title: "RF" },
        ];
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get accountingCompanyName() {
        return this.$store.state.user.company.name;
    }

    get accountingCompanyId() {
        return this.$store.state.companyAccountingFirm.id;
    }

    get isRootProfile() {
        return this.currentUser.isRoot;
    }

    get formattedScopes() {
        return this.items.map((scope) => {
            return {
                id: scope.id,
                name: scope.name,
                companyScope: scope,
            };
        });
    }

    get maxHeightRT() {
        return "calc(100vh - 208px)";
        const innHeight = window.innerHeight;
        const vhHeight = (250 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    iconMapping = {
        default: "$fa-bullseye",
        company: "$oss-company",
        activity: "$oss-activity",
        taxSystem: "$fa-gear",
    };

    childrenDialog: boolean = false;
    childrenValidLoading: boolean = false;
    selectedChildrenList = [];
    toMergeOrDeleteScopes = [];

    selectDuplicates(item) {
        this.selectedChildrenList = item.map((list) => {
            return {
                ...list,
                menu: false,
            };
        });
        this.childrenDialog = true;
    }

    get disableChildrenValid() {
        if (this.orphans && this.toMergeOrDeleteScopes.length) {
            return false;
        }
        if (this.toMergeOrDeleteScopes.length > 1) {
            return false;
        }
        return true;
    }

    getTitle(item) {
        return item.length + " éléments";
    }

    isCheckable(item) {
        return true;
    }

    getStatus(scope) {
        const status = {
            text: "",
            style: "font-weight: ligther; font-size: 8pt; color: ",
        };
        if (scope.scopeSharingStatus === "PENDING_VALIDATION" && this.isRootProfile) {
            status.text = "Partage à valider";
            status.style += "#f9b12a";
        } else if (scope.scopeSharingStatus === "PENDING_VALIDATION" && !this.isRootProfile) {
            status.text = "Partage en attente de validation";
            status.style += "#f9b12a";
        } else if (scope.scopeSharingStatus === "VALIDATE" && !scope.accountingCompany) {
            status.text = "Partage validé par bobbee";
            status.style += "green";
        }
        return status;
    }

    getTargets(scope) {
        if (this.ruleComponent) {
            return this.ruleComponent.getTargets([scope]);
        }
        return null;
    }

    getItems(item) {
        const items: Array<any> = [{ type: "subheader", title: "Règles" }];
        const rulesMap = {
            partitionTags: "Partition générique",
            accountingReviewLayout: "Dossier de révision",
            documentRules: "Règle sur les factures",
            exportOffice: "Export office",
            bookletTemplate: "Plaquette",
            exportTheme: "Thème document",
            extensions: "Extension",
            accountableAccountTables: "Plan comptable",
            bankTransactionWordingPatterns: "Analyse de libellé",
            operatingAccounts: "Tableau personnalisé",
            computedIndicators: "Indicateur personnalisé",
        };

        for (const rule in rulesMap) {
            if (item[rule].length) {
                const title = rulesMap[rule] + " : " + item[rule].length;
                items.push({ title: title, value: items.length });
            }
        }
        return items;
    }

    @Watch("search")
    @Watch("clientSearch")
    @Watch("activitySearch")
    @Watch("taxSystemSearch")
    onSearchModified(value) {
        this.firstRequestDone = false;
        this.items = [];
        this.pagination.page = 1;
    }

    @Watch("accountingCompanyId")
    resetItems() {
        this.items = [];
        this.pagination.page = 1;
    }

    get filteredScopeList() {
        if (this.orphans) {
            return [this.scopeList.filter((scope) => scope._count === 0)];
        }
        return this.scopeList;
    }

    getFilter() {
        const orConditions = [];
        if (this.clientSearch) {
            orConditions.push({
                clients_some: {
                    OR: [
                        { name_contains: this.clientSearch },
                        { siret_contains: this.clientSearch },
                    ],
                },
            });
        }
        if (this.activitySearch) {
            orConditions.push({
                activities_some: {
                    OR: [
                        { name_contains: this.activitySearch },
                        { description_contains: this.activitySearch },
                    ],
                },
            });
        }
        if (this.taxSystemSearch) {
            orConditions.push({ taxSystems_contains: this.taxSystemSearch });
        }
        if (this.search && this.search.length) {
            orConditions.push({ name_contains: this.search });
        }
        let andCondition;
        if (orConditions.length > 1) {
            andCondition = [];
            for (const orCondition of orConditions) {
                andCondition.push({
                    OR: orCondition,
                });
            }
        }
        const filter = {
            OR: orConditions.length === 1 ? orConditions[0] : undefined,
            AND: andCondition,
        };
        return filter;
    }

    @Apollo({
        query: COMPANY_SCOPES,
        fetchPolicy: "network-only",
        variables() {
            return {
                first: this.pagination.rowsPerPage,
                skip: (this.pagination.page - 1) * this.pagination.rowsPerPage,
                filter: this.getFilter(),
                accountingCompany: this.accountingCompanyId,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading) {
                if (data) {
                    this.firstRequestDone = true;
                    this.items.push(...data.companyScopes);
                    this.patternCount = data.companyScopesConnection.aggregate.count;
                } else {
                    this.pagination.page = 1;
                    this.patternCount = 0;
                }
            }
        },
    })
    items: Array<any> = [];

    @Apollo({
        query: COMPANY_SCOPES_LIST,
        variables() {
            return {
                accountingCompanyId: this.accountingCompanyId,
                duplicates: this.orphans ? false : true,
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return this.activeTab === "CompanyScopes";
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDuplicate = loading;
            if (!loading) {
                if (data) {
                    if (data.companyScopesList?.scopes?.length) {
                        this.scopeList = data.companyScopesList.scopes;
                    } else {
                        this.scopeList = [];
                    }
                }
            }
        },
    })
    scopeList: Array<any> = [];

    routeEdition(id?: string) {
        const params: any = {};
        if (id) {
            params.id = id;
        }
        let name = "company-scope-edition";
        if (!id) {
            name += "-new";
        }
        this.$router.push({
            name,
            params,
        });
    }

    async scopesMerge() {
        this.childrenValidLoading = true;
        if (this.orphans) {
            await this.$apollo.mutate({
                mutation: DELETE_SCOPES,
                variables: {
                    ids: this.toMergeOrDeleteScopes,
                },
            });
            this.refresh();
            // this.taskDeleleteIds = [];
        } else {
            const toKeepScopeId = this.toMergeOrDeleteScopes[0];
            const toMergeScopeIds = this.toMergeOrDeleteScopes.filter((id) => id !== toKeepScopeId);
            await this.$apollo.mutate({
                mutation: SCOPES_MERGE,
                variables: {
                    toKeepScopeId: toKeepScopeId,
                    toMergeScopeIds: toMergeScopeIds,
                },
            });
            this.refresh();
            this.routeEdition(toKeepScopeId);
        }
        this.childrenDialog = false;
        this.childrenValidLoading = false;
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.items) {
            this.$apollo.queries.items.refetch();
        }
        if (this.$apollo.queries && this.$apollo.queries.scopeList) {
            this.$apollo.queries.scopeList.refetch();
        } else {
            debugger;
        }
    }

    clearAllFilters() {
        this.search = "";
        this.taxSystemSearch = "";
        this.activitySearch = "";
        this.clientSearch = "";
    }
}

export default toNative(CompanyScopeTable);
</script>
